var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.22283 11L0.161754 5.90909L5.22283 0.818182H14.7285V11H5.22283ZM5.75479 9.72727H13.4558V2.09091H5.75479L1.9565 5.90909L5.75479 9.72727ZM11.6809 7.97727L10.8258 8.85227L5.77468 3.84091L6.62979 2.96591L11.6809 7.97727ZM6.62979 8.85227L5.77468 7.97727L10.8258 2.96591L11.6809 3.84091L6.62979 8.85227Z",
    fill: "white"
  })));
};
export { SvgDelete as ReactComponent };
export default __webpack_public_path__ + "assets/892a7d64.svg";